import { render } from "./DJSet.vue?vue&type=template&id=e649574c"
import script from "./DJSet.vue?vue&type=script&lang=js"
export * from "./DJSet.vue?vue&type=script&lang=js"

import "./DJSet.vue?vue&type=style&index=0&id=e649574c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__